import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CoreModule } from '@app/core';
import { SearchModule } from '@app/search';
import { SharedModule } from '@app/shared';
import { WigSummaryModule } from '@app/wig-summary';
import { WigTabsModule } from '@app/wig-tabs/wig-tabs.module';
import { WigTrackingRoutingModule } from './wig-tracking-routing.module';
import { WigTrackingComponent } from './wig-tracking.component';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SearchModule,
    SharedModule,
    WigSummaryModule,
    WigTrackingRoutingModule,
    WigTabsModule,
  ],
  exports: [WigTrackingComponent],
  declarations: [WigTrackingComponent],
  providers: [],
})
export class WigTrackingModule {}
